import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../routes";

/**
 * Shown when the whole visible range is empty — points back into the setup flow
 * instead of leaving a wall of blank day cells.
 */
const CalendarEmptyPeriod: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-4 flex flex-wrap items-center justify-center gap-3 rounded-2xl border border-grey-90 p-6 dark:border-primary-20">
      <p className="w-full text-center text-sm text-grey-40 dark:text-grey-60">
        {t("calendar.emptyPeriod")}
      </p>
      <Link to={ROUTES.CREATE_SESSION} className="btn btn-primary">
        <Plus size={18} strokeWidth={2} />
        <span>{t("sessions.createSession")}</span>
      </Link>
    </div>
  );
};

export default CalendarEmptyPeriod;
